import React, { useContext } from 'react'
import { cn } from '@s4l/utility-css'
import type { EmblaCarouselType } from 'embla-carousel'
import { CarouselContext } from '../index'

import { useNavigation } from '../hooks/useNavigation'

import styles from './styles.module.css'

const MAX_DOTS_TO_SHOW = 5

function getPosition(current: number, total: number) {
  if (total > MAX_DOTS_TO_SHOW && current > total - 3) {
    return total - MAX_DOTS_TO_SHOW
  }

  if (total > MAX_DOTS_TO_SHOW && current > 2) {
    return current - 2
  }

  return 0
}

export interface IDotsProps {
  startIndex?: number
  emblaApi?: EmblaCarouselType
}

export const Dots = ({ startIndex = 0, emblaApi }: IDotsProps) => {
  const { preset, variant } = useContext(CarouselContext)
  const { currentPage: current, numberOfPages } = useNavigation({ startIndex, emblaApi })

  return (
    <div className={cn(styles.dotsBase, variant && styles[variant])}>
      <div className={styles.container}>
        <div
          data-testid="dots"
          className={cn(styles.dots, {
            [styles.centered]: numberOfPages < 5,
            [styles.hideInDesktop]: preset === 'multiple-items',
          })}
          style={{
            transform: `translate(calc(var(--transform-direction) * ${getPosition(
              current - 1,
              numberOfPages
            )} * -14px))`,
          }}
        >
          {Array.from({ length: numberOfPages }).map((item, index) => {
            const key = `${item}${index}`
            return (
              <span
                data-testid="dot"
                key={key}
                className={cn(styles.dot, { [styles.selected]: index === current - 1 })}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}

Dots.displayName = 'Carousel.Dots'
